import type { Messages } from '@lingui/core'
import type { Locale } from '@skyground/contracts'

/** Where the chosen locale is persisted so a returning client keeps their language. */
export const LOCALE_STORAGE_KEY = 'locale'

/** The locale shown before any preference is known; also the source locale for every string. */
export const defaultLocale: Locale = 'en'

/**
 * Load a locale's compiled catalog. The template-literal dynamic import makes Vite emit one lazy
 * chunk per locale, so a language's messages are fetched only when it is actually activated — the
 * install-critical bundle never carries all 28 catalogs.
 */
export const loadCatalog = async (locale: Locale): Promise<Messages> => {
  const { messages } = (await import(`../../locales/${locale}/messages.po`)) as { messages: Messages }
  return messages
}
